// services/amministrationtag.service.js
import ApiService from './api.service';

const AmministartionTagService = {
  // Ottiene tutti i tag amministrativi
  getAllTags: () => 
    ApiService.fetch(`admin/admintags`),
  
  // Ottiene i tag assegnati a un terapeuta specifico (usando l'ID utente)
  getTherapistTags: (userId) => 
    ApiService.fetch(`admin/admintags/therapist/${userId}`),
  
  // Crea un nuovo tag amministrativo
  createTag: (tagData) => 
    ApiService.fetch(`admin/admintags`, {
      method: 'POST',
      body: JSON.stringify(tagData)
    }),
  
  // Aggiorna un tag esistente
  updateTag: (tagId, tagData) => 
    ApiService.fetch(`admin/admintags/${tagId}`, {
      method: 'PUT',
      body: JSON.stringify(tagData)
    }),
  
  // Elimina un tag
  deleteTag: (tagId) => 
    ApiService.fetch(`admin/admintags/${tagId}`, {
      method: 'DELETE'
    }),
  
  // Assegna un tag a un terapeuta
  assignTagToTherapist: (therapistId, tagId) => 
    ApiService.fetch(`admin/admintags/assign`, {
      method: 'POST',
      body: JSON.stringify({
        therapist_id: therapistId,
        amministration_tag_id: tagId
      })
    }),
  
  // Rimuove un tag da un terapeuta
  removeTagFromTherapist: (therapistId, tagId) => 
    ApiService.fetch(`admin/admintags/remove`, {
      method: 'POST',
      body: JSON.stringify({
        therapist_id: therapistId,
        amministration_tag_id: tagId
      })
    }),
  
  // Sincronizza completamente i tag di un terapeuta
  syncTagsForTherapist: (therapistId, tagIds) => 
    ApiService.fetch(`admin/admintags/sync`, {
      method: 'POST',
      body: JSON.stringify({
        therapist_id: therapistId,
        amministration_tag_ids: tagIds
      })
    }),
  
  // Cerca terapeuti per tag
  findTherapistsByTags: (tagIds) => 
    ApiService.fetch(`therapists/by-admintags`, {
      method: 'POST',
      body: JSON.stringify({
        amministration_tag_ids: tagIds
      })
    })
};

export default AmministartionTagService;